export const PAGE_SIZE = 25
